export const lookupTypes = [
    'agency', 'branch', 'customer', 'site', 'sitegroup', 'employee', 'zone'
];